export default "__VITE_ASSET__gW8pnvxD__"